import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { Info } from '@/domains/core/tamagoshi/icons/Info';
import { ResponsivePopover } from '@/domains/core/tamagoshi/ResponsivePopover/ResponsivePopover';
import { Div } from '@/domains/core/tamagoshiv2/components/Typography/Typography';

import {
  deductibleVatDescription,
  deductibleVatLabel,
  deductibleVatTitle,
} from './translations';

import styles from './styles.module.scss';

export const ZeroVatMention = () => {
  const [displayVatDeductibleInfoEnabled] = useBooleanFlags([
    'displayVatDeductibleInfo',
  ]);

  if (!displayVatDeductibleInfoEnabled) {
    return null;
  }

  return (
    <ResponsivePopover
      id="deductibleVat"
      title={<Div className={styles.title}>{deductibleVatTitle}</Div>}
      trigger={
        <div className={styles.container}>
          <Info width={16} height={16} />
          {deductibleVatLabel}
        </div>
      }
      text={deductibleVatDescription}
      position="left"
    />
  );
};
